"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Clock, Wrench, Star, CircleCheck as CheckCircle2 } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroHvacAtlanta() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const trustBadges = [{
    icon: ShieldCheck,
    text: "Independent Local Pros"
  }, {
    icon: Clock,
    text: "Prompt Scheduling"
  }, {
    icon: Wrench,
    text: "Transparent Estimates"
  }];
  const features = ["Experienced HVAC pros", "Energy-efficient systems", "Heating & cooling repair"];
  return <section id="herohvacatlanta" ref={sectionRef} className="relative overflow-hidden bg-background py-16 md:py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <div className="absolute -top-[20%] -right-[10%] h-[600px] w-[600px] rounded-lg bg-primary/5 blur-[100px]" />
        <div className="absolute -bottom-[20%] -left-[10%] h-[600px] w-[600px] rounded-lg bg-secondary/5 blur-[100px]" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-8">
          
          {}
          <div className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="space-y-4">
              <Badge variant="secondary" className="px-3 py-1 text-sm">
                Local HVAC Network
              </Badge>
              <h1 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl xl:text-6xl">
                Atlanta HVAC Repair & Installation — <span className="text-primary">Climate Control You Can Trust</span>
              </h1>
              
              <div className="flex flex-col gap-2 pt-2">
                {features.map((feature, index) => <div key={index} data-index={index} className="flex items-center gap-2 text-lg text-muted-foreground">
                    <CheckCircle2 className="size-5 text-primary shrink-0" />
                    <span>{feature}</span>
                  </div>)}
              </div>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Link to="#bookingrequest">
                <Button size="lg" className="w-full text-base sm:w-auto h-12 px-8">
                  Request a Quote
                </Button>
              </Link>
            </div>

            {}
            <div className="grid grid-cols-1 gap-4 pt-6 sm:grid-cols-3 border-t border-border/50">
              {trustBadges.map((badge, index) => <div key={index} data-index={index} className="flex items-center gap-2">
                  <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                    <badge.icon className="size-4 text-primary" />
                  </div>
                  <span className="text-sm font-medium text-foreground">{badge.text}</span>
                </div>)}
            </div>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-[500px] lg:max-w-none transition-all duration-1000 delay-200 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="relative aspect-[4/5] overflow-hidden rounded-2xl shadow-2xl lg:aspect-square">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/hvac_technician_hero.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/hvac_technician_hero.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/hvac_technician_hero.webp-wvc-sizes" alt="Independent HVAC pro working on an air conditioning unit in Atlanta" className="h-full w-full object-cover" loading="eager" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 rounded-xl bg-background/95 p-4 shadow-lg backdrop-blur-sm sm:bottom-8 sm:left-8 sm:right-auto sm:w-64">
                <div className="flex items-center gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                    <ShieldCheck className="size-6 text-primary" />
                  </div>
                  <div>
                    <p className="font-default font-bold text-foreground">Local Pros</p>
                    <p className="text-sm text-muted-foreground">Heating & Cooling</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}